function safeJsonParse(string, returnStringAsFallback = false) {
  if (!string || typeof string !== 'string') return returnStringAsFallback ? string : null;

  try {
    return JSON.parse(string);
  } catch (e) {
    return returnStringAsFallback ? string : null;
  }
}

export default safeJsonParse;
